import { campaignSet } from '@civitime/game-server/lib/saga-tools/Data.effects'

export function * qrUnlocked(event) {
  yield campaignSet(`sessions/${event?.target}/buildings/${event?.buildingType}/stepsPlayed/${event?.moduleStep.toString()}`, (v) => ({
    ...v,
    qrUnlocked: true
  }))
}